import { registerFragment } from '@redwoodjs/web/apollo';

registerFragment(gql`
  fragment BillBSOFragment on BuySellOrder {
    id
    slug
    flagged
    status
    orderDate
    customFields
    currencyCode
    exchangeRate
    broker {
      user {
        fullName
      }
    }

    # Purchase data
    vendor {
      name
    }
    vendorContact {
      name
    }
    vendorSo
    vendorSalesTerms
    vendorBillTo {
      displayName
    }

    # Sales data
    customer {
      name
    }
    customerContact {
      name
    }
    customerPo
    customerSalesTerms
    billTo {
      displayName
    }

    bills {
      id
      status
      type
    }
    lineItems {
      id
      buySellOrderId
      billLineItems {
        billId
      }
      product {
        productId: id
        weightPerInventoryUnit
        cartonsPerPallet
        description
        countryOfOrigin
        # Including all the commodity attributes for document generation
        commodity {
          name
        }
        commodityStyle {
          name
        }
        commoditySize {
          name
        }
        commodityUnit {
          name
        }
        commodityLabel {
          name
        }
      }
      buyPrice
      sellPrice
      buyCurrencyPrice
      sellCurrencyPrice
      deliveredPrice
      deliveredCurrencyPrice
      unitsOrdered
      unitsShipped
      unitsInvoiced
    }
    expenses {
      ...ExpenseAttributes
      ...ExpenseFinanceEntities
    }
    documents {
      ...BillDocumentFragment
    }
    shipment {
      ...BillShipmentFragment
    }
  }
`);
